/**
 * EmailStore — manages resume-emails collection for document-triggered sending.
 *
 * Each email doc:
 * {
 *   candidateId, projectId, to, cc[], subject, body,
 *   status: 'pending'|'sending'|'sent'|'failed'|'delivered'|'opened'|'bounced',
 *   sendgridMessageId, sendgridEvents: [],
 *   direction: 'outbound'|'inbound',
 *   calendarAccepted: bool,
 *   error, createdAt, updatedAt, sentAt
 * }
 */
export class EmailStore {
    constructor(db) {
        this._db = db;
        this._collection = db.collection('resume-emails');
        this._unsub = null;
        this._emails = [];
        this._listeners = [];
    }

    subscribeCandidate(candidateId) {
        this.dispose();
        this._unsub = this._collection
            .where('candidateId', '==', candidateId)
            .orderBy('createdAt', 'desc')
            .onSnapshot(snap => {
                this._emails = snap.docs.map(d => ({ id: d.id, ...d.data() }));
                this._notify();
            }, err => {
                console.error('EmailStore subscription error:', err);
            });
    }

    subscribeProject(projectId) {
        this.dispose();
        this._unsub = this._collection
            .where('projectId', '==', projectId)
            .orderBy('createdAt', 'desc')
            .onSnapshot(snap => {
                this._emails = snap.docs.map(d => ({ id: d.id, ...d.data() }));
                this._notify();
            }, err => {
                console.error('EmailStore subscription error:', err);
            });
    }

    onChange(fn) { this._listeners.push(fn); }
    getAll() { return this._emails; }
    getById(id) { return this._emails.find(e => e.id === id) || null; }

    async createOutbound(data) {
        const ref = await this._collection.add({
            candidateId: data.candidateId,
            projectId: data.projectId,
            to: data.to,
            cc: data.cc || [],
            subject: data.subject,
            body: data.body,
            status: 'pending',
            direction: 'outbound',
            sendgridMessageId: null,
            sendgridEvents: [],
            calendarAccepted: false,
            error: null,
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
            sentAt: null,
        });
        return ref.id;
    }

    dispose() {
        if (this._unsub) { this._unsub(); this._unsub = null; }
        this._emails = [];
    }

    _notify() {
        for (const fn of this._listeners) fn(this._emails);
    }
}
